window.LOGIN_BRANDS = {
    BLUE_STONE_LANE: 'bluestone_lane',
    FULHAM_SHORE: 'fulham_shore',
};

window.LOGIN_BRANDS_BUSINESS_IDS = {
    [LOGIN_BRANDS.FULHAM_SHORE]: 'fulham'
};